export default __webpack_public_path__ + "static/media/ellipse-2.6610cc6c.svg";